// extracted by mini-css-extract-plugin
var _1 = "error-LBI4u";
var _2 = "input-EjwNy";
var _3 = "label-DI61E";
var _4 = "wrapper-RoDqK";
export { _1 as "error", _2 as "input", _3 as "label", _4 as "wrapper" }
